import { makeStyles} from '@material-ui/core';
import { IServiceUserInfo } from '../../datasolvr/ServicesFacade';
import { Modal } from '../ui/Modal';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';


const useStyles = makeStyles((theme: any) => ({
    subtitle:{
        display:'flex',
        justifyContent:'start',
        alignItems:'center',
        fontSize: 14,
        fontWeight: 400,
        color: "#374251",
        marginBottom: 10
    }
}));

interface Props {
    applicationUser: IServiceUserInfo
    eaterGroupName: string
    eaterGroupUserDeleteModalHidden: boolean,
    setEaterGroupUserDeleteModalHidden: React.Dispatch<React.SetStateAction<boolean>>;
    removeEaterGroupUser : (applicationUserId: string) => void
}

export const EaterGroupUserDeleteModal: React.FC<Props> = ({applicationUser,eaterGroupName,eaterGroupUserDeleteModalHidden,setEaterGroupUserDeleteModalHidden,removeEaterGroupUser}) => {
    const classes = useStyles();

    return (
        <Modal title={"Remove " + applicationUser.content.name} hidden={eaterGroupUserDeleteModalHidden} setHidden={setEaterGroupUserDeleteModalHidden}>
            <div>
                <div className={classes.subtitle}>
                    Are you sure you wannt remove {applicationUser.content.name} from {eaterGroupName}
                </div>
                <CancelCrudButtons 
                    hidden={eaterGroupUserDeleteModalHidden} 
                    setHidden={setEaterGroupUserDeleteModalHidden} 
                    postButtonText={"Remove " + applicationUser.content.name}
                    isDelete={true} 
                    postDeleteForEntity={() => removeEaterGroupUser(applicationUser.content.id)} />
            </div>
        </Modal>
    );
}